import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: inherit;
	align-self: end;
	justify-content: center;
	.motif-tooltip-trigger-wrap {
		display: flex;
		align-items: center;
	}
`;
